/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-sign/QaItpSendCopyDialog.tsx
 * FILE_ID: JOBHUB-QA-ITP-SEND-COPY-001
 * PURPOSE: Ask whether Send uses the signed or unsigned copy.
 */
import { useEffect, useState } from 'react'
import { MobileSheet, useIsMdUp } from '@quotech/ui'

// Reused from: packages/job-hub/src/jobs/tabs/job-qa/itp-export/QaItpSizeDialog.tsx (dialog card)

export function QaItpSendCopyDialog({
  open,
  name,
  signedEnabled,
  onCancel,
  onSend,
}: {
  open: boolean
  name: string
  signedEnabled: boolean
  onCancel: () => void
  onSend: (kind: 'signed' | 'unsigned', name: string) => void
}) {
  const desktop = useIsMdUp()
  const [draft, setDraft] = useState(name)
  useEffect(() => { if (open) setDraft(name) }, [name, open])
  useEffect(() => {
    if (!open || !desktop) return undefined
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onCancel() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [desktop, onCancel, open])
  if (!open) return null
  const body = (
    <>
      <label className="mt-2 block text-xs text-muted-foreground">
        Filename
        <input aria-label="Filename" value={draft} onChange={(event) => setDraft(event.target.value)} className="mt-1 w-full rounded border border-border bg-background px-2 py-1 text-sm" />
      </label>
      <div className="mt-4 flex flex-col gap-2">
        <button type="button" disabled={!signedEnabled} onClick={() => onSend('signed', draft)} className="min-h-[44px] rounded-md bg-primary px-2.5 py-1.5 text-xs font-medium text-primary-foreground disabled:opacity-50 md:min-h-0">
          Send signed copy
        </button>
        {!signedEnabled ? <p className="text-xs text-muted-foreground">No accepted signature</p> : null}
        <button type="button" onClick={() => onSend('unsigned', draft)} className="min-h-[44px] rounded-md border border-border px-2.5 py-1.5 text-xs font-medium md:min-h-0">
          Send unsigned copy
        </button>
        <button type="button" onClick={onCancel} className="min-h-[44px] rounded-md px-2.5 py-1.5 text-xs text-muted-foreground md:min-h-0">
          Cancel
        </button>
      </div>
    </>
  )
  if (!desktop) return <MobileSheet open={open} onClose={onCancel} title="Send">{body}</MobileSheet>
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4">
      <div role="dialog" aria-label="Send" className="w-full max-w-sm rounded-lg bg-card p-4 shadow-lg">
        <p className="text-sm font-semibold">Send</p>
        {body}
      </div>
    </div>
  )
}
